module.exports = __webpack_public_path__ + "img/identity-card.d288367a.png";